import CryptocurrencyIcon from './CryptocurrencyIcon'

export default CryptocurrencyIcon
